export default "__VITE_ASSET__BTesYca$__"